import { ComboDataDTO } from '../ComboDataDTO'

export interface KitTypeOptionDTO extends ComboDataDTO {}

export interface StockItemPresentationOptionDTO extends ComboDataDTO {
  stockItemId?: number | null
  presentationDescription?: string | null
  fullDescription?: string | null
}

export interface KitListItemDTO {
  kitId: number
  description: string
  stockItemsKitTypeName: string
  active: boolean
}

export interface KitItemDetailDTO {
  localKey: string
  stockItemsKitDetailId: number | null
  stockItemPresentationId: number | null
  itemLabel: string
  quantity: string
  mainItem: boolean
  stockItemPresentation: StockItemPresentationOptionDTO | null
}

export interface KitDetailDTO {
  kitId: number
  description: string
  active: boolean
  observations: string
  stockItemsKitType: KitTypeOptionDTO | null
  details: KitItemDetailDTO[]
  deletedDetailIds: number[]
}

export interface KitItemSaveDTO {
  stockItemsKitDetailId?: number | null
  stockItemPresentationId: number
  quantity: number
  mainItem: boolean
}

export interface KitSaveDTO {
  kitId?: number | null
  description: string
  active: boolean
  observations: string
  stockItemsKitTypeId: number
  details: KitItemSaveDTO[]
  deletedDetailIds: number[]
}

export interface KitsListQueryParams {
  multiSortMeta?: unknown
  filterDTO?: unknown
  cardFilterDTO?: unknown
  activeFilter?: boolean[]
}

export const defaultKitDetailDTO: KitDetailDTO = {
  kitId: -1,
  description: '',
  active: true,
  observations: '',
  stockItemsKitType: null,
  details: [],
  deletedDetailIds: [],
}
